import { Col, Image, Row } from "antd";
import { Content } from "antd/es/layout/layout";
import "./dashboard.scss";
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import SaleStatistics from "./SaleStatistics/saleStatistics";
import Wallets from "./wallet/wallet";
import InProgress from "./inprogress/inprogress";
import ChartPurchase from "./charpurchase/chartpurchase";
import { getSessionStorage, setSessionStorage } from "../../tools/services";

const Dashboard = () => {
	const { _currentUser } = useSelector((state) => state?.another);
	const [isPreviewVisible, setPreviewVisible] = useState(false);

	// const [isModalNotif, setIsModalNotif] = useState(true);

	useEffect(() => {
		const getNotif = getSessionStorage("forcenotif");
		if (getNotif !== "NE140508538.jpg") {
			setPreviewVisible(true);
		}
	}, []);

	const handlePopupShowForceImage = (visible, prevVisible) => {
		setPreviewVisible(visible);
		setSessionStorage("forcenotif", "NE140508538.jpg");
	};

	return (
		<>
			<Content
				style={{
					margin: "0 24px 0 ",
					padding: "1rem",
					minHeight: "100%",
				}}>
				<div className="dashboard-container">
					<Row gutter={30}>
						<Col xxl={8} xl={10} lg={12} md={24} sm={24} xs={24}>
							<Wallets _currentUser={_currentUser} />
							<InProgress />
						</Col>
						<Col xxl={8} xl={10} lg={12} md={24} sm={24} xs={24}>
							<SaleStatistics />
						</Col>
					</Row>
					<Row gutter={30}>
						<Col xxl={16} xl={20} lg={24} md={24} sm={24} xs={24}>
							<ChartPurchase />
						</Col>
					</Row>
				</div>
			</Content>

			{/* <Modal title="اطلاعیه" centered open={isModalNotif} onCancel={() => setIsModalNotif((prev) => !prev)} footer={<></>}>
				<p>
					نماینده گرامی,
					<br />
					لطفا جهت شرکت در نظرسنجی طرح تسهیم درآمد بر روی{" "}
					<a href="https://aptel.ir/srv" target="_blank">
						لینک
					</a>{" "}
					کلیک نمایید.
				</p>
			</Modal> */}

			<Image
				width={0}
				preview={{
					visible: isPreviewVisible,
					onVisibleChange: handlePopupShowForceImage,
					toolbarRender: () => null,
				}}
				src={process.env.PUBLIC_URL + "/assets/files/NE140508538.jpg"}
			/>
		</>
	);
};

export default Dashboard;
